
import client from '@/plugins/axios2'

export default {

  auth_request : ({commit}, user) => {
    return new Promise(async (resolve, reject) => {
      commit('auth_request')

      var email = user.user.ds_email
      var pass  = user.user.password

      await client.post('usuario/login', {
        'ds_email': email,
        'password': pass
      })
      .then(response => {
        if (response.data.status) {
          var usuario = {
            'id': response.data.login.id,
            'ds_email': response.data.login.ds_email,
            'tp_usuario':  response.data.login.tp_usuario,
            'avatar': response.data.login.foto ? response.data.login.foto : null
          }
          var token = response.data.login.token.original.access_token
          var expira = response.data.login.token.original.expires_in
          var menus = JSON.stringify(response.data.login.menus)
          commit('auth_success', { token, expira, usuario, menus})
          client.defaults.headers.common['Authorization'] = 'Bearer ' + token;
          resolve(response)
        } else if (response.data.status === false) {
          resolve(response)
        }
      })
      .catch(e => {
        reject(e)
      })
    })
  },
  auth_refresh : async ({commit, state}) => {

    if (!state.token) return

    await client.get('usuario/refresh', {
      'headers': {'Authorization': 'Bearer ' + state.token }
    })
    .then(response => {
      var token = response.data.access_token;
      var expira = (response.data.expires_in)

      localStorage.setItem('token', token)
      localStorage.setItem('expira', expira)

      commit('auth_refresh_token', { token, expira })
      client.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    })
    .catch(e => {
      console.log('Erro refresh token', e)
    })
  },
  auth_logout : async ({commit, dispatch}) => {
    localStorage.clear()
    await client.post('usuario/logout')
    commit('auth_logout')
  },
  reset_login : ({commit}) => {
    localStorage.clear()
    commit('reset_login')
  },
  contador: ({commit, state, dispatch}) => {

    /*function formataCronometro (tempo) {
      if (tempo >= 0) {
        // Pega a parte inteira dos minutos
        var min = parseInt(tempo/60)

        // Calcula os segundos restantes
        var seg = tempo%60
  
        // Formata o número menor que dez, ex: 08, 07, ...
        if(min < 10){
            min = "0"+min
            min = min.substr(0, 2);
        }
        if(seg <=9){
            seg = "0"+seg
        }
  
        // Cria a variável para formatar no estilo hora/cronômetro
        return '00:' + min + ':' + seg
      } else {
        return "00:00:00"
      }  
    }

    setInterval(() => {
      //console.log(state.tempo)
      var tempo = state.tempo
      if (!tempo || tempo < 0 || tempo === 0) {
        commit('contador', { tempo: 0, tempoform: "00:00:00"})
      } else {
        state.tempo = state.tempo - 1
        let descCron = formataCronometro(state.tempo)
        commit('contador', { tempo: state.tempo, tempoform: descCron })
      }
    }, 1000);*/
   
  }
  

}


// WEBPACK FOOTER //
// ./src/views/Login/_store/actions.js